import { api } from '@/lib/api';
import type { IApiResponse, IAuditConfig, IAuditConfigUpdate, IAuditLogPageResponse } from '@skystone/shared';

export const auditApi = {
  getConfigs: async (): Promise<IAuditConfig[]> => {
    const result = await api.get<IApiResponse<IAuditConfig[]>>('/audit/config');
    return result.data;
  },

  updateConfig: async (eventType: string, data: IAuditConfigUpdate): Promise<IAuditConfig> => {
    const result = await api.put<IApiResponse<IAuditConfig>>(`/audit/config/${eventType}`, data);
    return result.data;
  },

  getLogs: async (params: { page?: number; pageSize?: number; eventType?: string; actorUsername?: string }): Promise<IAuditLogPageResponse> => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set('page', String(params.page));
    if (params.pageSize) searchParams.set('pageSize', String(params.pageSize));
    if (params.eventType) searchParams.set('eventType', params.eventType);
    if (params.actorUsername) searchParams.set('actorUsername', params.actorUsername);
    const query = searchParams.toString();
    const url = query ? `/audit/logs?${query}` : '/audit/logs';
    const result = await api.get<IApiResponse<IAuditLogPageResponse>>(url);
    return result.data;
  },
};
